import numberUtils from '@/utils/numberUtils'
import currencyFormatter from 'currency-formatter'

export function formatAmount (amount, currency = 'USD') {
  return amount ? currencyFormatter.format(amount, currency) : '0'
}

export function calculatePercentage (dividend = 0, divider = 1) {
  return divider - 0 ? ((dividend / divider) * 100).toFixed(2) : '0'
}

export class SafeNumber {
  constructor (initVal) {
    this.setValue(initVal)
  }
  setValue (val) {
    this.value = String(val)
  }
  toSafeNumber () {
    return Number(this.value) || 0
  }
  toNumber () {
    return Number(this.value)
  }
  toSafeString () {
    const stringVal = this.value ? String(Number(this.value)) : 'NaN'
    return stringVal === 'NaN' ? 'N/A' : stringVal
  }
  toString () { return this.toSafeString() }
  valueOf () { return this.toSafeString() }
  isNaN () {
    return !this.value || Number.isNaN(Number(this.value))
  }
  [Symbol.toPrimitive] (hint) {
    if (hint === 'number') {
      return this.toSafeNumber()
    }
    if (hint === 'string') {
      return this.toSafeString()
    }
    return this.toSafeNumber()
  }
  addBy (val) {
    let result = ''
    if (['string', 'number'].includes(typeof val)) {
      if ((new SafeNumber(val)).isNaN()) {
        result = this.value
      } else {
        result = String(this.toSafeNumber() + Number(val))
      }
    } else if (val instanceof SafeNumber) {
      if (val.isNaN()) {
        result = this.value
      } else {
        result = String(this.toSafeNumber() + val.toSafeNumber())
      }
    }
    return new SafeNumber(result)
  }
  multiplyBy (val) {
    let result = ''
    if (['string', 'number'].includes(typeof val)) {
      if ((new SafeNumber(val)).isNaN() || this.isNaN()) {
        result = ''
      } else {
        result = String((this.toSafeNumber() * Number(val)).toFixed(2))
      }
    } else if (val instanceof SafeNumber) {
      if (val.isNaN() || this.isNaN()) {
        result = ''
      } else {
        result = String((this.toSafeNumber() * val.toSafeNumber()).toFixed(2))
      }
    }
    return new SafeNumber(result)
  }
}

const amountUtil = {
  format (amount) {
    const formattedAmount = numberUtils.formatDecimal(String(amount) || '')
    return formattedAmount ? parseFloat(formattedAmount).toFixed(2) : 0
  },
}

export default amountUtil
